import { __decorate, __metadata } from "tslib";
import { Pretend, Post, Get, Put, Headers as PretendHeaders } from 'pretend';
import { parseApiDates } from '@spa-frontend/date-lib';
export const PARSE_RESULT_METADATA_KEY = Symbol('parseResultMetadata');
const parseResult = (props) => {
    return (_target, _key, 
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    descriptor) => {
        const fn = descriptor.value;
        descriptor.value = async function (...args) {
            const result = await fn.apply(this, args);
            const tupleProps = props.map((prop) => prop.split('.'));
            return parseApiDates(result, tupleProps);
        };
        Reflect.defineMetadata(PARSE_RESULT_METADATA_KEY, props, _target, _key);
        return descriptor;
    };
};
// tslint:disable:no-any
class BalanceCustomerAccountBlueprint {
    balanceCustomerAccount(_p0, _p1) {
        /**/
    }
}
__decorate([
    PretendHeaders('Content-Type: application/json'),
    Post('/payments/fast-finance-link/{fastFinanceLinkToken}/balance'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", Object)
], BalanceCustomerAccountBlueprint.prototype, "balanceCustomerAccount", null);
class CreateUserPaymentSessionBlueprint {
    createUserPaymentSession(_p0, _p1, _p2) {
        /**/
    }
}
__decorate([
    PretendHeaders('Content-Type: application/json'),
    parseResult(['tokenValidUntil']),
    Post('/payments/fast-finance-link/{token}/user-payment-sessions', true),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object, Object]),
    __metadata("design:returntype", Object)
], CreateUserPaymentSessionBlueprint.prototype, "createUserPaymentSession", null);
class GetAccountBalanceBlueprint {
    getAccountBalance(_p0, _p1) {
        /**/
    }
}
__decorate([
    parseResult(['customerAccountDto.bookingEntries.dueDate']),
    Get('/payments/fast-finance-link/{token}/account-balance', true),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", Object)
], GetAccountBalanceBlueprint.prototype, "getAccountBalance", null);
class GetFastFinanceLinkBlueprint {
    getFastFinanceLink(_p0) {
        /**/
    }
}
__decorate([
    parseResult(['masterData.publicData.address.status.since']),
    Get('/payments/fast-finance-link/{token}'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Object)
], GetFastFinanceLinkBlueprint.prototype, "getFastFinanceLink", null);
class GetPaymentStatusBlueprint {
    getPaymentStatus(_p0, _p1) {
        /**/
    }
}
__decorate([
    Get('/payments/fast-finance-link/{token}/payment-status/{paymentRequestToken}'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", Object)
], GetPaymentStatusBlueprint.prototype, "getPaymentStatus", null);
class UpdateCustomerPaymentMethodBlueprint {
    updateCustomerPaymentMethod(_p0, _p1) {
        /**/
    }
}
__decorate([
    Put('/payments/fast-finance-link/{token}/payment-method/{paymentRequestToken}'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", Object)
], UpdateCustomerPaymentMethodBlueprint.prototype, "updateCustomerPaymentMethod", null);
// tslint:enable:no-any
export function getClient(endpoint, token, configure = (client) => client) {
    const bearerToken = (request) => {
        if (token) {
            request.options.headers = new Headers(request.options.headers);
            request.options.headers.set('Authorization', `bearer ${token}`);
        }
        return request;
    };
    return {
        BalanceCustomerAccount: configure(Pretend.builder())
            .requestInterceptor(bearerToken)
            .target(BalanceCustomerAccountBlueprint, endpoint),
        CreateUserPaymentSession: configure(Pretend.builder())
            .requestInterceptor(bearerToken)
            .target(CreateUserPaymentSessionBlueprint, endpoint),
        GetAccountBalance: configure(Pretend.builder())
            .requestInterceptor(bearerToken)
            .target(GetAccountBalanceBlueprint, endpoint),
        GetFastFinanceLink: configure(Pretend.builder())
            .requestInterceptor(bearerToken)
            .target(GetFastFinanceLinkBlueprint, endpoint),
        GetPaymentStatus: configure(Pretend.builder())
            .requestInterceptor(bearerToken)
            .target(GetPaymentStatusBlueprint, endpoint),
        UpdateCustomerPaymentMethod: configure(Pretend.builder())
            .requestInterceptor(bearerToken)
            .target(UpdateCustomerPaymentMethodBlueprint, endpoint)
    };
}
